import React, { useLayoutEffect, useState } from "react";
import { Row, Col } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LoginForm from "../../../forms/LoginForm";
//import loginBg from "../../../../images/login.svg";
import { useAuth } from "../../../contexts/auth/index";
import schema from "../../../schemas/loginSchema";
import "./style.css";

// FZ-1499: Onboarding redirect hook
import useOnboardingRedirect from "./useOnboardingRedirect";

/* const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
}; */

const LoginPage = () => {
  // FZ-1499: Listen for onboarding redirect
  useOnboardingRedirect();
  const auth = useAuth();
  const loginInProgress = auth.loginInProgress;

  const submitForm = (data) => {
    auth.login(data);
  };

  const [col, setCol] = useState(12);

  useLayoutEffect(() => {
    function updateCol() {
      if (window.innerWidth < 660) setCol(24);
      else setCol(12);
    }
    window.addEventListener("resize", updateCol);
    updateCol();
    return () => window.removeEventListener("resize", updateCol);
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
    resolver: yupResolver(schema),
  });

  return (
    <Row gutter={16} style={{ height: "100%" }}>
      <Col span={col} className="bgImage">
        <div
          /*   style={{
              ...styles.bgLogin,
              backgroundImage: `url(${loginBg})`,
              height: "100%",
            }}*/
          className="bgLogin"
        />
      </Col>

      <Col span={col}>
        <LoginForm
          control={control}
          errors={errors}
          onSubmit={handleSubmit(submitForm)}
          loading={loginInProgress}
        />
      </Col>
    </Row>
  );
};

export default LoginPage;
